import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '../ui/Button';
import { UserActions } from './Header/UserActions';
import { useAuth } from '../../contexts/AuthContext';
import { User } from 'lucide-react';

interface HeaderProps {
  onMenuClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm dark:border-gray-800 dark:bg-gray-800 sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 dark:text-gray-200 lg:hidden"
        onClick={onMenuClick}
      >
        <span className="sr-only">Open sidebar</span>
        <Menu className="h-6 w-6" aria-hidden="true" />
      </button>

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="flex items-center gap-x-4 lg:gap-x-6">
          {user && (
            <div className="flex items-center gap-3">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900">
                <User className="h-5 w-5 text-primary-600 dark:text-primary-300" />
              </div>
              <span className="text-sm font-medium text-gray-900 dark:text-white">
                Bonjour {user.first_name}
              </span>
              {user.agency_name && (
                <span className="inline-flex items-center rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800 dark:bg-primary-900/30 dark:text-primary-300">
                  {user.agency_name}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="flex flex-1 items-center justify-end gap-x-4 lg:gap-x-6">
          <UserActions />
        </div>
      </div>
    </header>
  );
};